import gql from 'graphql-tag';

const TERMINATE_SEGMENT = gql`
  mutation($params: TerminateSegmentInput!) {
    terminateSegment(params: $params) {
      merchantName
      merchantUuid
      offerUuid
      segments {
        uuid
        cashbackAmount
        cashbackDailyLimit
        cashbackPercentage
        baseCashbackAmount
        baseCashbackPercentage
        promotionType
        updatedBy
      }
    }
  }
`;

export default TERMINATE_SEGMENT;
